<template>
  <div class="centered-container">

    <md-content class="md-elevation-3">
      <div class="title">
        <img
          src="/static/logo_azul.png"
          style="height: 30px">
      </div>

      <div class="form">
        <md-field>
          <label>Digite sua nova senha</label>
          <md-input
            v-model="newpassword"
            type="password"
            autofocus/>
        </md-field>
        <md-field>
          <label>Repetir senha</label>
          <md-input
            v-model="newpasswordrepeat"
            type="password"/>
        </md-field>
        <div style="max-width: 300px">
          <password-strength-bar :password="newpassword" />
        </div>
      </div>
      <div
        v-if="newpassword != newpasswordrepeat || !newpassword || !newpasswordrepeat"
        class="actions md-layout md-alignment-center-space-between">
        <md-button
          class="md-raised md-primary"
          style="width: 100%;"
          disabled
          @click.enter="resetPassword">Enviar</md-button>
      </div>
      <div
        v-else
        class="actions md-layout md-alignment-center-space-between">
        <md-button
          class="md-raised md-primary"
          style="width: 100%;"
          @click.enter="resetPassword">Enviar</md-button>
      </div>

      <div
        v-if="loading"
        class="loading-overlay">
        <md-progress-spinner
          :md-stroke="2"
          md-mode="indeterminate"/>
      </div>
    </md-content>
  </div>
</template>

<script>
import { httpLogin } from '../api/backend';
import PasswordStrengthBar from '../password/PasswordStrengthBar.vue'

export default {
  name: 'Resetpassword',
  components: {
    PasswordStrengthBar
  },
  data() {
    return {
      loading: false,
      newpassword: '',
      newpasswordrepeat: '',
    };
  },

  methods: {

    resetPassword() {
      this.loading = true;
      httpLogin.post('application.post-passwd_recovery', {
          token: this.$route.params.mailtoken,
          new_password: this.newpassword,
        })
        .then(response => {
          this.loading = false
          if (response.data.status === 1) {
            this.$toasted.show('Por favor, realize o login.', {
              theme: 'outline',
              position: 'bottom-right',
              duration: 5000,
              type: 'success',
              icon: 'check_circle'
            });
            this.$router.push({ path: '/' })
          }
        })
        .catch(error => {
          this.$toasted.show(error.response.data.error_message, {
              theme: 'outline',
              position: 'bottom-right',
              duration: 5000,
              type: 'error',
              icon: 'error_outline'
            });
          this.loading = false
        })
    },
  }
};
</script>

<style type="text/css">
.centered-container {
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	height: 100vh;
}
.title {
	text-align: center;
	margin-bottom: 30px;
	color: #1b8af1;
	font-size: 34px;
	font-weight: 300;

}


.form {
	margin-bottom: 60px;
}

.md-elevation-3 {
	z-index: 1;
	padding: 40px;
	width: 100%;
	max-width: 400px;
	position: relative;
	border-radius: 5px;
	border: 1px solid transparent;
	background-color: #fff;
	box-shadow: 0 2px 8px rgba(0,0,0,.07);
	transition: all .5s;
}
.card {
	border-radius: 5px;
	border: 1px solid transparent;
	background-color: #fff;
	box-shadow: 0 2px 8px rgba(0,0,0,.07);
	transition: all .5s;
}
.loading-overlay {
	z-index: 10;
	top: 0;
	left: 0;
	right: 0;
	position: absolute;
	width: 100%;
	height: 100%;
	background: rgba(255, 255, 255, 0.9);
	display: flex;
	align-items: center;
	justify-content: center;
}

.button-success {
	color: #fff;
	background-color: #44bb52;
	border-color: rgba(0, 0, 0, 0);
}
</style>



// WEBPACK FOOTER //
// src/public/password/Resetpassword.vue